var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPressHoldImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 258.89 41.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        letter-spacing: -.04em;\n      }\n\n      .cls-3 {\n        letter-spacing: -.05em;\n      }\n\n      .cls-4 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-5 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-6 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-7 {\n        font-family: Futura-Bold, Futura;\n        font-size: 14px;\n        font-weight: 700;\n      }\n\n      .cls-8 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-9 {\n        letter-spacing: 0em;\n      }\n\n      .cls-10 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-11 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-12 {\n        letter-spacing: 0em;\n      }\n\n      .cls-13 {\n        fill: #2e2e2b;\n      }\n\n      .cls-14 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-15 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-16 {\n        letter-spacing: -.03em;\n      }\n\n      .cls-17 {\n        letter-spacing: -.02em;\n      }\n\n      .cls-18 {\n        letter-spacing: 0em;\n      }\n\n      .cls-19 {\n        letter-spacing: -.04em;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(39.62 28.87)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 0,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 8.6,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 17.49,
    y: 0
  }, "E"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 25.35,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 33.27,
    y: 0
  }, "S &amp; "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 60.05,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 71.03,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 82.76,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 89.82,
    y: 0
  }, "D "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 104.22,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-18",
    x: 109.07,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-2",
    x: 122.16,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 131.73,
    y: 0
  }, "G"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 143.28,
    y: 0
  }, "E "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 154.9,
    y: 0
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 162.13,
    y: 0
  }, "O "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-10",
    x: 177.8,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-3",
    x: 185.65,
    y: 0
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 195.03,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 204.85,
    y: 0
  }, "E")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m24.48,20.42c-.28-.64-.93-1.41-2.42-1.42h-.01c-.52,0-.93.08-1.26.21-.13-.39-.34-.73-.61-1.01-.51-.5-1.21-.75-2.05-.74-.54.01-1.04.14-1.44.38-.48-.89-1.4-1.49-2.46-1.49-.39,0-.76.08-1.1.23v-6.71c0-1.6-1.26-2.9-2.81-2.9s-2.81,1.28-2.81,2.35v12.83c-.02.47-.04.88-.06,1.23-1.68-1.98-3.66-3.27-4.8-3.4-.64-.08-1.28.11-1.81.53-.47.37-.77.88-.83,1.4-.19,1.72.94,3.92,2.51,6.96,1.16,2.24,2.47,4.78,3.61,7.81,1.61,4.26,5.47,4.35,8.64,4.35.07,0,.13,0,.2,0,2.76,0,5.87-.51,8.01-4.28.42-.69,1.8-3.3,1.8-7.75v-6.32c0-.73,0-1.55-.31-2.26Zm-1.11,2.26v6.32c0,4.18-1.33,6.57-1.59,7.01l-.03.04c-1.77,3.13-4.3,3.56-6.77,3.56-3.63,0-6.31-.24-7.51-3.43-1.17-3.1-2.56-5.79-3.67-7.95-1.4-2.72-2.51-4.86-2.36-6.16.01-.11.11-.29.3-.44.12-.09.34-.23.64-.23.04,0,.07,0,.11,0,.66.08,3,1.39,4.84,4.19.16.23.41.36.68.34,0,0,.02,0,.03,0,.34-.04.61-.3.66-.65.1-.74.17-1.54.23-3.07,0,0,0-.02,0-.03v-12.85c0-.22.59-.93,1.39-.93s1.39.66,1.39,1.48v13.1c0,.39.32.71.71.71s.71-.32.71-.71v-4.63c.26-.36.67-.58,1.1-.58.77,0,1.39.66,1.39,1.48v.34s0,.07,0,.1c0,0,0,0,0,0v4.39c0,.39.32.71.71.71s.71-.32.71-.71v-4.47c0-.15.07-.28.18-.4.2-.21.53-.32.94-.33.44-.01.79.1,1.01.33.31.31.37.79.36,1.15v5.46c0,.39.32.71.71.71s.71-.32.71-.71v-5.02c.2-.24.46-.38,1.09-.38,0,0,0,0,0,0,.77,0,1,.29,1.12.56.19.44.19,1.1.19,1.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m5.91,11.73c-.25,0-.5-.13-.63-.37-.48-.85-.74-1.82-.74-2.8,0-3.14,2.55-5.69,5.69-5.69s5.69,2.55,5.69,5.69c0,.97-.25,1.93-.72,2.78-.2.35-.64.48-.99.28-.35-.2-.48-.64-.28-.99.35-.63.54-1.34.54-2.07,0-2.34-1.9-4.24-4.24-4.24s-4.24,1.9-4.24,4.24c0,.73.19,1.45.55,2.08.2.35.08.79-.27.99-.11.06-.24.09-.36.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m3.84,13.81c-.23,0-.45-.11-.6-.31-1.03-1.45-1.57-3.16-1.57-4.94C1.67,3.84,5.51,0,10.23,0s8.56,3.84,8.56,8.56c0,1.77-.54,3.47-1.55,4.92-.23.33-.69.41-1.01.18-.33-.23-.41-.69-.18-1.01.84-1.2,1.29-2.61,1.29-4.08,0-3.92-3.19-7.1-7.1-7.1s-7.1,3.19-7.1,7.1c0,1.48.45,2.9,1.3,4.1.23.33.15.78-.17,1.02-.13.09-.27.13-.42.13Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPressHoldImage);
export default __webpack_public_path__ + "static/media/press-hold-image.e3429af16c34339e2a06db65aaf354e1.svg";
export { ForwardRef as ReactComponent };